<template lang="pug">
  b-card
    p PAYMENT DETAILS
    content-loader(:height="7", v-if="alert.loading")
    //- div(v-else="")
    //-   h4 COMING SOON
    //-   p We are currently working on an automated payment system. For the time being, Wall will directly contact you to arrange payments for items sold.
    div(v-else-if="!showForm")
      h4 WE DON'T HAVE YOUR DETAILS YET
      p Update your information to ensure smooth shipping and payment
      b-button.btn-outline(@click="showForm  = true") ADD DETAILS
    form.mt-3(v-else="", @submit.prevent='onSubmit')
      .row
        .col-md-6
          b-form-group
            label BANK
            b-form-select(type='text', :options="bankOptions", v-model='inputForm.bank_name', required='', placeholder='Bank')
        .col-md-6
          b-form-group
            label ACCOUNT TYPE
            b-form-select(type='text', :options="accountOptions", v-model='inputForm.type', required='', placeholder='Type')
        .col-md-6
          b-form-group
            label ACCOUNT NUMBER
            b-form-input(type="number", max="99999999999", v-model='inputForm.account_number', required='', placeholder='Account Number')
      .form-group
        button-load(type="submit", :flag="alert.busy", label="SAVE", classes="btn-outline")
</template>

<script>
import standardMix from '@/mixins/standardMix';
import { userService } from '@/services';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      showForm: false,
      inputForm: {
        bank_name: '',
        account_number: '',
        type: '',
      },
      accountOptions: ['Cheque', 'Savings', 'Business', 'Deposit'],
      bankOptions: ['Absa',
        'African Bank',
        'Bidvest Bank',
        'Capitec Bank',
        'Discovery',
        'First National Bank',
        'FirstRand Bank',
        'Investec Bank',
        'Nedbank',
        'Sasfin Bank',
        'Standard Bank',
        'TymeBank'],
    };
  },
  computed: {
  },
  methods: {
    async onSubmit() {
      try {
        this.busy();
        await userService.updateBankAccount({ form: this.inputForm, id: this.account.user.artist_id });
        this.success('Bank account updated');
      } catch (error) {
        this.error(error);
      }
    },
  },
  async created() {
    this.loading();
    try {
      const bankAccount = await userService.getBankAccount(this.account.user.artist_id);
      if (bankAccount) {
        this.showForm = true;
        this.inputForm = bankAccount;
      }
    } catch (error) {
      this.showForm = false;
    }
    this.clear();
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/AccountBankAccount.vue